import { lazy } from 'react';
import { IA_KEY } from 'helpers/ia-logic';
import { PAGE_LAYOUT_VARIANT } from 'features/App';

import { handleRouteEnter, watchActions as watchAppointmentsActions } from './Appointments.saga';
import {
  handleRouteEnterCalendar,
  watchActions as watchCalendarActions,
} from './AvailabilityCalendar/AvailabilityCalendar.saga';
import {
  handleRouteBlockOffTimeStaffEnter,
  handleRouteEditBlockOffTimeEnter,
  watchActions as watchBlockOffTimeActions,
} from './BlockOffTime/BlockOffTime.saga';
import { watchCalendarLinksActions, handleCalendarLinksRouteEnter } from './CalendarLinks/CalendarLinks.saga';
import { watchYieldManagementActions } from '../YieldManagement';

const AvailabilityCalendar = lazy(() =>
  import(/* webpackChunkName: "appointments-calendar" */ './AvailabilityCalendar')
);
const AppointmentsContainer = lazy(() => import(/* webpackChunkName: "appointments-main" */ './AppointmentsContainer'));
const AddBlockOffTimeStaffForm = lazy(() =>
  import(
    /* webpackChunkName: "appointments-block-add" */ './BlockOffTime/BlockOffTimeStaffForm/AddBlockOffTimeStaffFormContainer'
  )
);
const EditBlockOffTimeStaffForm = lazy(() =>
  import(
    /* webpackChunkName: "appointments-block-edit" */ './BlockOffTime/BlockOffTimeStaffForm/EditBlockOffTimeStaffFormContainer'
  )
);
const CalendarLinks = lazy(() =>
  import(/* webpackChunkName: "appointments-calendar-links" */ './CalendarLinks/CalendarLinksContainer')
);
const CancelAppointment = lazy(() =>
  import(/* webpackChunkName: "appointments-cancel" */ './CancelAppointment/CancelAppointmentContainer')
);

export default [
  {
    path: '/appointments/:venueId/block-off-time/staff/add',
    component: AddBlockOffTimeStaffForm,
    iaKey: IA_KEY.APPOINTMENTS_PAGE,
    pathSagas: [watchBlockOffTimeActions, watchCalendarActions],
    locationSagas: [handleRouteBlockOffTimeStaffEnter],
    pageLayout: PAGE_LAYOUT_VARIANT.NARROW,
    isFixedPage: true,
  },
  {
    path: '/appointments/:venueId/block-off-time/staff/edit/:id',
    component: EditBlockOffTimeStaffForm,
    iaKey: IA_KEY.APPOINTMENTS_PAGE,
    pathSagas: [watchBlockOffTimeActions, watchCalendarActions],
    locationSagas: [handleRouteBlockOffTimeStaffEnter, handleRouteEditBlockOffTimeEnter],
    pageLayout: PAGE_LAYOUT_VARIANT.NARROW,
    isFixedPage: true,
  },
  {
    path: '/appointments/:venueId/calendar-links',
    component: CalendarLinks,
    iaKey: IA_KEY.APPOINTMENTS_PAGE,
    pathSagas: [watchCalendarLinksActions],
    locationSagas: [handleCalendarLinksRouteEnter],
  },
  {
    path: '/appointments/:venueId/cancel/:reservationId',
    component: CancelAppointment,
    iaKey: IA_KEY.APPOINTMENTS_PAGE,
    pathSagas: [watchAppointmentsActions, watchCalendarActions],
    locationSagas: [handleRouteEnter],
    pageLayout: PAGE_LAYOUT_VARIANT.NARROW,
    hideVenueSelector: true,
  },
  {
    path: '/appointments/:venueId/calendar/:view?',
    component: AvailabilityCalendar,
    iaKey: IA_KEY.APPOINTMENTS_PAGE,
    pathSagas: [watchCalendarActions, watchBlockOffTimeActions, watchYieldManagementActions],
    locationSagas: [handleRouteEnterCalendar],
    hasMultipleColumns: true,
    isFixedPage: true,
  },
  {
    path: '/appointments/:venueId',
    component: AppointmentsContainer,
    iaKey: IA_KEY.APPOINTMENTS_PAGE,
    pathSagas: [watchAppointmentsActions, watchBlockOffTimeActions, watchYieldManagementActions],
    locationSagas: [handleRouteEnter],
  },
];
